exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".footer-submenu__title[data-v-72617c17]{color:#fff;font-family:Mukta,sans-serif;text-transform:uppercase;font-weight:700;font-size:14px;margin-top:0}.footer-list__item[data-v-72617c17]{display:block;font-size:14px;margin:0 0 10px;position:relative;padding-left:10px;padding-top:5px;padding-bottom:5px}.footer-list__item[data-v-72617c17]:before{content:\"\";position:absolute;top:50%;transform:translateY(-50%);left:0;width:0;height:0;border-style:solid;border-width:2.2px 0 2.2px 3.2px;border-color:transparent transparent transparent hsla(0,0%,100%,.4)}.footer-list__link[data-v-72617c17]{color:#fff;text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-72617c17","scoped":true,"hasInlineConfig":true}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/footer/footer-menu.vue
// module id = 858
// module chunks = 0